<!-- cv Audio -->
<template>
  <div data-app>
    <div class="row">

      <div class="col-md-12 pt-4">
        <div class="row m-0 col-12 pb-3 bg-white border-r-16 pt-4">
          <div class="col-md-4 p-0">
            <span class="leatext_job_heading_by_new_home">Manage Audios</span>
          </div>
          <div class="
            col-md-8
            p-0
            row
            m-0
            d-flex
            justify-content-end
            new_list_st_by_ch
          ">
            <button type="button" class="text-center custom-add-new-record-button btn_dash_ch___ mr-2" fab small
              @click="createFormEnable">
              Add New Audio

            </button>
          </div>
        </div>
        <div class="col-md-12 row p-0 m-0">

          <div data-app class="p-0">
            <div class="row mt-1 mx-0 new_list_st_by_ch">
              <div class="row m-0 col-8 py-0 pl-0" style="height: fit-content">

                <div class="empty_div_jobsAdd" v-if="
                  data.length == 0
                ">
                  You don't have any Audio.
                </div>
                <div class="col-md-4 row m-0 mt-4 pt-0 pr-0" v-for="(item, index) in data" :key="index"
                  :class="index == 0 || index % 3 == 0 ? 'pl-0' : ''">
                  <div class="col-md-12 row m-0 border-r-16 p-4" :class="
                    audio_ID && audio_ID === item.id
                      ? 'bg-info-new'
                      : 'bg-white'
                  ">
                    <div class="col-md-12 p-0">
                      <h4 class="mb-0" style="
                          color: #242424;
                          font-size: 18px;
                          font-weight: bold;
                        ">
                        {{ item.title }}
                      </h4>
                    </div>
                    <div class="col-md-12 p-0 pb-2 pt-4">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4 class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          ">
                          <img src="/images/job_page/Date_posted.svg" alt="..." class="pr-4" /><span
                            class="tooltiptextch">Date Added</span>
                        </h4>
                        <span>{{
                        moment(item.created_at).format("DD MMMM, YYYY hh:mm A")
                        }}</span>
                      </div>
                    </div>
                    <hr class="col-md-12 p-0 mt-4 mb-4" style="background: rgba(53, 162, 229, 0.25)" />
                    <div class="_btn_gridddd3333_ch33 _btn_gridddd p-0 m-0">
                      <div class="p-0" @click="editButtonClick(item)">
                        <button type="button" class="new_details_job_dashbord_list2_ch2">
                          <img class="dashbord25" src="\images/job_application/Edit_icon.svg" alt="" width="25"
                            height="25" />
                          <div class="v-btn__content">Edit</div>
                        </button>
                      </div>
                      <div class="p-0" @click="playAudio(item)">
                        <button type="button" class="new_details_job_dashbord_list2_ch2">
                          <img class="dashbord25" src="\images/job_application/Video_icon_.svg" alt="" width="25"
                            height="25" />
                          <div class="v-btn__content">Play</div>
                        </button>
                      </div>
                      <div class="p-0" @click="downloadAudio(item)" style="">
                        <button type="button" class="new_details_job_dashbord_list2_ch2">
                          <img class="dashbord25" src="\images/job_application/Download_light.svg" alt="" width="25"
                            height="25" />
                          <div class="v-btn__content">Download</div>
                        </button>
                      </div>
                      <div class="p-0" @click="askUserAboutDelete(item)">
                        <button type="button" class="new_details_job_dashbord_list2" style="
                                background: rgba(147, 6, 6, 0.05) !important;
                                border-color: rgba(147, 6, 6, 0.5) !important;
                                height: 100%;
                              ">
                          <img class="dashbord" src="\images/job_application/Delete.svg" alt="" width="22" height="22"
                            style="height: 22px !important;width: 20px !important;" />
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
                <hr class="col-md-12 p-0 mt-4" style="background: rgba(53, 162, 229, 0.25)" />

              </div>
              <div class="col-lg-4 p-0 alwyes sidbar_ch_new3" v-if="alwyes">
                <div class="col-lg-12 pl-0 pr-0 pt-4">
                  <div class="card sidebar">
                    <div class="card-body widget cardbodych" style="">
                      <h5 class="" style="
                              font-style: normal;
                              font-weight: 700 !important;
                              font-size: 30px;
                              line-height: 120%;
                              color: #005696;
                            ">
          Advertise with  <br />
          job4u.pk
          </h5>
        </div>
        <div class="col-12">
          <p
            style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 140%;
                        color: #666666;
                        background: transparent !important;
                      "
          >
          Contact us to display your
          Ad here to reach tens of
          thousands of people!

          </p>
                      <button style="
                              padding: 12px 16px;
                              gap: 8px;
                              background: #35a2e5;
                              border-radius: 53px;
                              font-style: normal;
                              font-weight: 400;
                              font-size: 16px;
                              line-height: 140%;
                              color: #ffffff;
                            ">
                        <img
              class="dashbord123"
              src="\images/job_application/Call.svg"
              alt=""
              style="margin-right: 10px"
            />
              Contact Sales
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 p-0 sidbar_ch_new3 mt-4" v-if="createForm || updateForm || PlayForm">

                <v-card class="border-t-lr-16 bg-info-new" v-if="createForm">
                  <div style="padding: 3%">
                    <div class="row m-0 p-0">
                      <div class="col-md-12 p-0 text-end" style="z-index: 1;">
                        <button class="badge badge-danger badge-pill" @click="cancel()">
                          X
                        </button>
                      </div>
                      <div style="position: relative;font-weight: 600;font-size: 21px;color: #005696;position: relative"
                        class="col-md-4 p-0 margin_nagtive mb-4">
                        Add New Audio
                      </div>
                    </div>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <div class="row">
                        <div class="col-md-12 py-0 input_label_s_ch">
                          <label for="Title" class="pt-4">Title</label>
                          <v-text-field v-model="title" :rules="nameRules" required></v-text-field>
                        </div>

                        <div class="col-md-12 py-0 input_label_s_ch2 ">
                          <label for="Choose your short intro audio">Choose your short intro audio</label>
                          <v-file-input @change="getDuration" v-model="audio" accept="audio/*">
                          </v-file-input>
                        </div>
                        <div class="col-md-12 pt-0 pb-0 input_label_s_ch22">
                          <label>Note: Please upload Audio not more than 30 seconds</label>
                        </div>
                      </div>

                      <div class="row" style="margin-top: 2rem">

                        <div class="col-md-6 button_by_save_cv_ch">
                          <v-btn class="
                              btn btn-sm btn-success
                              font-weight-bold
                            " @click="createIntroAudio" :disabled="
                                title === '' || (title === null && audio === '') || audio === null
                                  ? true
                                  : false
                              ">
                            <b-spinner small type="grow" v-if="submitting"></b-spinner>
                            Save
                          </v-btn>
                        </div>
                        <div class="col-md-6 button_by_cencl_cv_ch">
                          <v-btn class="
                            btn btn-sm btn-danger
                            font-weight-bold
                          " @click="cancel">
                            Cancel
                          </v-btn>
                        </div>
                      </div>
                    </v-form>
                  </div>
                </v-card>
                <v-card class="border-t-lr-16 bg-info-new" v-if="updateForm">
                  <div style="padding: 3%">
                    <div class="row m-0 p-0">
                      <div class="col-md-12 p-0 text-end" style="z-index: 1;">
                        <button class="badge badge-danger badge-pill" @click="cancel()">
                          X
                        </button>
                      </div>
                      <div style="position: relative;font-weight: 600;font-size: 21px;color: #005696;position: relative"
                        class="col-md-4 p-0 margin_nagtive mb-4">
                        Edit Audio
                      </div>
                    </div>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <div class="row">
                        <video-player v-if="activeAudio !== ''" class="video-player-box_audio" ref="videoPlayer" :options="playerOptions"
                          :playsinline="true" customEventName="customstatechangedeventname">
                        </video-player>
                      </div>
                      <div class="row">
                        <div class="col-md-12 py-0 input_label_s_ch">
                          <label for="Title" class="pt-4">Title</label>
                          <v-text-field v-model="title" :rules="nameRules" required></v-text-field>
                        </div>

                        <div class="col-md-12 py-0 input_label_s_ch2 ">
                          <label for="Choose your short intro audio">Choose your short intro audio</label>
                          <v-file-input @change="getDuration" v-model="audio" accept="audio/*">
                          </v-file-input>
                        </div>
                        <div class="col-md-12 pt-0 pb-0 input_label_s_ch22">
                          <label>Note: Please upload Audio not more than 30 seconds</label>
                        </div>
                      </div>

                      <div class="row" style="margin-top: 2rem">

                        <div class="col-md-6 button_by_save_cv_ch">
                          <v-btn class="
                              btn btn-sm btn-success
                              font-weight-bold
                            " @click="updateIntroAudio" :disabled="
                                title === '' || (title === null && audio === '') || audio === null
                                  ? true
                                  : false
                              ">
                            <b-spinner small type="grow" v-if="submitting"></b-spinner>
                            Save
                          </v-btn>
                        </div>
                        <div class="col-md-6 button_by_cencl_cv_ch">
                          <v-btn class="
                            btn btn-sm btn-danger
                            font-weight-bold
                          " @click="cancel">
                            Cancel
                          </v-btn>
                        </div>
                      </div>
                    </v-form>
                  </div>
                </v-card>
                <v-card class="border-t-lr-16 bg-info-new" v-if="PlayForm">
                  <div style="padding: 3%">
                    <div class="row m-0 p-0">
                      <div class="col-md-12 p-0 text-end" style="z-index: 1;">
                        <button class="badge badge-danger badge-pill" @click="cancel()">
                          X
                        </button>
                      </div>
                      <div style="position: relative;font-weight: 600;font-size: 21px;color: #005696;position: relative"
                        class="col-md-4 p-0 margin_nagtive mb-4">
                        Play Audio
                      </div>
                    </div>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <div class="row">
                        <video-player v-if="activeAudio !== ''" class="video-player-box_play" ref="videoPlayer" :options="playerOptions"
                          :playsinline="true" customEventName="customstatechangedeventname">
                        </video-player>
                      </div>
                    </v-form>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Confirm Delete Item -->

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-card-title>
            <span class="headline">Do you really want to DELETE this item?</span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom-submit-button" text @click="dialog = false">No</v-btn>
            <v-btn class="custom-cancel-button" text @click="deleteItem">
              <b-spinner small type="grow" v-if="deleting"></b-spinner>Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
import Swal from "sweetalert2";
import JobSeekerService from "@/MainServices/JobSeekerService.js";
import moment from "moment";

export default {
  data() {
    return {
      mediaUrl: MEDIA_URL,
      loading: true,
      dialog: false,
      deleteId: null,
      deleting: false,
      success: false,
      submitting: false,
      token: `Bearer ${localStorage.getItem("token")}`,
      valid: true,
      audio_ID: null,
      createForm: false,
      updateForm: false,
      PlayForm:false,
      title: "",
      Audio: "",

      cvId: null,
      nameRules: [
        (v) => !!v || "Audio title is required",
        (v) =>
          (v && v.length <= 20) ||
          "Audio title must be less than 20 characters",
      ],
      headers: [
        { text: "Title", value: "title" },
        { text: "Added On", value: "created_at" },
        { text: "Actions", value: "Action" },
        // { text: "Audio", value: "path" },
        // { text: "Action", value: "action" },
      ],
      alwyes: true,
      data: [],
      activeAudio: "",
      playerOptions: {
        // Audiojs options
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "audio/mp3",
            src: this.activeAudio,
          },
        ],
        poster: "/static/images/author.jpg",
      },
    };
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
    document.head.appendChild(link);
    this.getInititalData();
  },
  // components: {
  //   audioPlayer,
  // },
  // computed: {
  //   player() {
  //     return this.$refs.audioPlayer.player;
  //   },
  // },
  methods: {
    moment: function () {
      return moment();
    },
    getInititalData() {
      JobSeekerService.getMyAudios()
        .then((res) => {
          this.data = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getDuration(item) {
      this.audio = item;
    },
    cancel() {
      this.dialog = false;
      this.createForm = false;
      this.updateForm = false;
      this.PlayForm = false;
      this.title = "";
      this.audio = "";
      // this.mediaUrl = MEDIA_URL;
      this.audio_ID = null;
      this.loading = false;
      this.success = true;
      this.submitting = false;
      this.alwyes = true;
    },
    createFormEnable() {
      this.alwyes = false;
      this.career_level = "";
      this.createForm = true;
      this.updateForm = false;
      this.PlayForm = false;
    },
    createIntroAudio() {
      if (!this.submitting) {
        if (this.audio == "" || this.title == "") {
          Swal.fire({
            title: "",
            text: "Please, provide correct data!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          return;
        }
        this.submitting = true;
        let formData = new FormData();
        formData.append("title", this.title);
        formData.append("audio", this.audio);
        axios.defaults.headers.common["Authorization"] = this.token;
        axios
          .post(`${API_URL}/job-seeker-store-intro-audio`, formData)
          .then((res) => {
            this.cancel();
            this.getInititalData();
            Swal.fire({
              title: "",
              text: res.data,
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          })
          .catch(() => {
            this.loading = false;
            this.submitting = false;
            Swal.fire({
              title: "",
              text: "Something went wrong!",
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          });
      }
    },
    updateIntroAudio() {
      if (!this.submitting) {
        if (this.title == "") {
          Swal.fire({
            title: "",
            text: "Please, provide correct data!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          return;
        }
        this.submitting = true;
        let formData = new FormData();
        formData.append("cvId", this.cvId);
        formData.append("title", this.title);
        if (this.audio !== "") {
          formData.append("audio", this.audio);
        }

        axios.defaults.headers.common["Authorization"] = this.token;
        axios
          .post(
            `${API_URL}/job-seeker-update-intro-audio/${this.cvId}`,
            formData
          )
          .then((res) => {
            this.cancel();
            this.getInititalData();
            Swal.fire({
              title: "",
              text: res.data,
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          })
          .catch(() => {
            this.loading = false;
            this.submitting = false;
            Swal.fire({
              title: "",
              text: "Something went wrong!",
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          });
      }
    },
    changeStatus(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/job-seeker-set-cv-default/${item.id}`)
        .then((res) => {
          this.loading = false;
          this.success = true;

          Swal.fire({
            title: "",
            text: "Status updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    editButtonClick(item) {
      this.alwyes = false;
      this.createForm = false;
      this.updateForm = true;
      this.PlayForm = false;
      this.playerOptions.sources[0].src =
      this.mediaUrl + "videos/raw/" + item.path;
      // this.audio = this.mediaUrl;
      this.activeAudio = "1";
      this.title = item.title;
      this.audio_ID = item.id;
      this.cvId = item.id;
    },
    downloadAudio(item) {
      window.open(this.mediaUrl + "videos/raw/" + item.path);
    },
    playAudio(item) {
      this.PlayForm = true;
      this.alwyes = false;
      this.createForm = false;
      this.updateForm = false;
      this.audio_ID = item.id;
      this.playerOptions.sources[0].src =
        this.mediaUrl + "videos/raw/" + item.path;
      this.activeAudio = "1";
    },

    deleteButtonClick(item) {
      JobSeekerService.deleteMyAudio(item)
        .then((res) => {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel();
        })
        .catch(() => {
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.loading = false;
        });
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },

    deleteItem() {
      this.deleteButtonClick(this.deleteId);
    },
  },
};
</script>


<style>
.container {
  max-width: none !important;
}
</style>